<template>
  <div id="exam-list">
    <BottomBar />
    <div v-if="!exams || !exams.length">
      <Empty :loading="isLoading" :icon="true" title="暂无测试报告" subtitle="您还没有参与任何课堂测试" />
    </div>
    <div v-else>
      <div class="cover">
        <img
          src="https://anyteach3.oss-cn-shenzhen.aliyuncs.com/assets/exam-bgd.png?x-oss-process=image/resize,h_400"
        />
      </div>
      <main class="items">
        <h2>课堂测试报告</h2>
        <Item v-for="exam in exams" :key="exam.id" :data="exam" />
      </main>
    </div>
  </div>
</template>
<script>
import Empty from "../public/Empty"
import Item from "./Item"
import BottomBar from "@/components/public/footer"
export default {
  name: "ExamList",
  components: {
    Empty,
    Item,
    BottomBar,
  },
  data() {
    return {
      exams: undefined,
      isLoading: true,
    }
  },
  created() {
    this.wechatInit()
    this.getData()
  },
  methods: {
    wechatInit() {
      this.$wxShare({
        title: "课堂测试",
        imgUrl: window.logo2019,
        desc: "点击进入 AnyTeach 课堂测试报告，看看老师对你的评语。",
        link: window.homePageUrl + this.$route.fullPath,
      })
    },
    async getData() {
      try {
        const value = await this.$api.exam.LIST()
        this.isLoading = false
        if (value.code === "1000") {
          this.exams = value.msg
          return
        }
        this.exams = []
      } catch (error) {
        this.isLoading = false
        Sentry.captureException(
          `${this.$route.fullPath} getData() failed: ${JSON.stringify(error)}`,
        )
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";
#exam-list {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  margin-bottom: 20px;
  .cover {
    background: #ffa501;
    height: 145px;
    width: 100%;
    display: flex;
    padding-top: 10px;
    justify-content: center;
    img {
      text-align: center;
      height: 155px;
      display: block;
      margin: 0 auto;
      position: absolute;
      right: 0;
    }
  }
  main {
    padding: 0 5% 0 5%;
  }
  h2 {
    font-size: 1.25rem;
    margin-top: -30px;
    margin-bottom: 25px;
    color: $dark-blue;
  }
  .empty {
    height: 70vh;
  }
}
</style>
